import { FC, useEffect, useState } from 'react'
import { API } from '@/api'
import DatePicker from '@pages/Admin/CRM/components/base/DatePicker/DatePicker'
import CheckboxLabel from '@pages/Admin/CourseSettings/components/CheckboxLabel/CheckboxLabel'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'
import dayjs from '@store/timetable/dayjs.config'
import cn from './index.module.css'

interface Props {
  changed: boolean
  applyToCompleted: boolean
  onApplyChange: (value: boolean) => void
  effectiveFrom: string
  onDateChange: (value: string) => void
  scope: {
    group_id?: number
    teacher_id?: number
    student_id?: number
    course_id?: number
  }
}

const SalaryRecalculationFields: FC<Props> = ({
  changed,
  applyToCompleted,
  onApplyChange,
  effectiveFrom,
  onDateChange,
  scope,
}) => {
  const [dates, setDates] = useState<string[]>([])
  const [error, setError] = useState(false)
  const { group_id, teacher_id, student_id, course_id } = scope
  useEffect(() => {
    if (!changed || !applyToCompleted) return
    let active = true
    setDates([])
    setError(false)
    API.get('reports/salary-lesson-dates', {
      params: { group_id, teacher_id, student_id, course_id },
    })
      .then((response: any) => {
        if (!active) return
        if (response?.data?.status !== 'success') {
          setError(true)
          return
        }
        setDates(response.data.data?.dates ?? [])
      })
      .catch(() => {
        if (active) setError(true)
      })
    return () => {
      active = false
    }
  }, [changed, applyToCompleted, group_id, teacher_id, student_id, course_id])
  if (!changed) return null
  return (
    <div className={cn.recalculation}>
      <p className={cn.warning}>
        Вы изменяете ставку. Она будет применяться к будущим занятиям. Прошлые
        начисления сохранятся, если не включить перерасчёт.
      </p>
      <CheckboxLabel
        label="Применить ставку и за предыдущие занятия"
        value={applyToCompleted}
        onChange={onApplyChange}
      />
      {applyToCompleted && (
        <FieldWrapper label="Применять ставку с даты">
          <DatePicker
            controlSize="compact"
            value={effectiveFrom ? dayjs(effectiveFrom) : null}
            onChange={(date) => onDateChange(date?.format('YYYY-MM-DD') ?? '')}
            format="DD.MM.YYYY"
            disabledDate={(date) => date.isAfter(dayjs(), 'day')}
            dateRender={(date) => (
              <div className={cn.calendarDay}>
                {date.date()}
                {dates.includes(date.format('YYYY-MM-DD')) && (
                  <span className={cn.lessonDot} />
                )}
              </div>
            )}
          />
          <small>
            {error
              ? 'Не удалось загрузить даты занятий. Дату начала перерасчёта можно указать вручную.'
              : 'Точками отмечены занятия, по которым уже есть отчёт.'}
          </small>
        </FieldWrapper>
      )}
    </div>
  )
}
export default SalaryRecalculationFields
